/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import {ReduceStore} from 'flux/utils';
import Immutable from 'immutable';

import {FooterConstants} from './footer-actions';
import {Dispatcher} from '../../flux-helpers';

const DOWNLOADABLE_CLIP_LIBRARY_ID = 15973;

class FooterStore extends ReduceStore {
    getInitialState() {
        return Immutable.Map({
            footerSections: Immutable.Map()
        });
    }

    reduce(state, action) {
        switch (action.actionType) {
        case FooterConstants.GET.SUCCESS:
            let list = action.list;

            if (action.listName === 'tools') {
                list = list.update(
                    'items',
                    items => items.filter(
                        item => item.get('id') !== DOWNLOADABLE_CLIP_LIBRARY_ID
                    )
                );
            }

            state = state.setIn(['footerSections', action.listName], list);
            break;

        default:
            break;
        }
        return state;
    }
}

let store = new FooterStore(Dispatcher);
export default store;
